import { create } from 'zustand'

interface UiLayoutState {
  isContentFullscreen: boolean
  toggleContentFullscreen: () => void
  setContentFullscreen: (value: boolean) => void
}

export const useUiLayoutStore = create<UiLayoutState>((set) => ({
  isContentFullscreen: false,
  toggleContentFullscreen: () =>
    set((state) => ({ isContentFullscreen: !state.isContentFullscreen })),
  setContentFullscreen: (value) => set({ isContentFullscreen: value }),
}))
